<script>
  import config from "../config.json";
  import network from "../network.json";
  import { _ } from "../i18n";
  import moment from "moment-timezone";

  import FusionCharts from "fusioncharts";
  import Timeseries from "fusioncharts/fusioncharts.timeseries";
  import SvelteFC, { fcRoot } from "svelte-fusioncharts";

  fcRoot(FusionCharts, Timeseries);

  import { onMount } from "svelte";

  import {
    Col,
    Row,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardHeader,
    Spinner,
    Alert,
  } from "sveltestrap";

  import CentralineHistoryForm from "./CentralineHistoryForm.svelte";
  //import ChartItem from './ChartItem.svelte';

  let form = {
    device: "",
    fromDate: "",
    toDate: "",
  };

  let isLoading = false;

  //measurement fetched from API
  let chartDataset;
  let measureUnits = {};

  //error message
  let errorMessage = "";

  const urlBase = network.urlBasePOST;
  // const user = network.postAccount;
  // const apiKey = network.apiKey;

  const measurementLabels = Object.keys(config.labelMappings);
  const dbLabels = Object.values(config.labelMappings);
  const units = config.unitMappings;

  const prepareDate = (date) => {
    let month, day, year;
    (month = "" + (date.getMonth() + 1)),
      (day = "" + date.getDate()),
      (year = date.getFullYear());

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  const getChartConfig = (data, label, index) => {
    //console.log("getting chart config for " + label);
    const schema = [
      {
        name: $_("time"),
        type: "date",
        format: "%d/%m/%Y, %H:%M:%S",
      },
      {
        name: $_(label),
        type: "number",
      },
    ];
    // const jsonSchema=schema.jsonify();
    // const jsonData = data.jsonify();
    const fusionDataStore = new FusionCharts.DataStore(),
      fusionTable = fusionDataStore.createDataTable(data, schema);

    return {
      type: "timeseries",
      width: "100%",
      height: 450,
      renderAt: "chart-container" + "-" + index,
      dataSource: {
        data: fusionTable,
        caption: { text: $_(label) },
        //subcaption: { text: $_() },
        xAxis: {
          outputtimeformat: {
            day: "%d/%m/%Y, %H:%M:%S",
          },
        },
        tooltip: {
          outputtimeformat: {
            day: "%d/%m/%Y, %H:%M:%S",
          },
        },
        yAxis: {
          plot: {
            value: $_(label),
            type: "line",
          },
          format: {
            round: "2",
          },
          title: $_(label) + ": (" + measureUnits[label] + ")",
        },
      },
    };
  };

  const fetchHistoryData = async () => {
    isLoading = true;
    chartDataset = {};
    errorMessage = "";
    console.log("fetching data");

    // const payload = {
    //   // lacentralinaAccount: user,
    //   // lacentralinaKey: apiKey,
    //   IDtag: form.device,
    //   timestampFrom: new Date(form.fromDate).toISOString(),
    //   timestampTo: new Date(form.toDate).toISOString(),
    // };
    const timestampFrom = new Date(form.fromDate).toISOString();
    const timestampTo = new Date(form.toDate).toISOString();  
    //console.log(payload);
    const response = await fetch(
      urlBase +
        "?idtag=" +
        form.device +
        "&fromDate=" +
        timestampFrom +
        "&toDate=" +
        timestampTo
    );
    if (!response.ok) {
      isLoading = false;
      throw new Error("API does not respond - " + response.statusText);
    }
    const data = await response.json();
    console.log(data);

    //let fetched = data.reverse();
    let fetched = data;
    if (fetched.length === 0) {
      isLoading = false;
      errorMessage = $_("noData");
      return;
    }
    const options = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    //Populate measure unit
    measurementLabels.map((label) => {
      if (fetched[0][label]) {
        //console.log(fetched[0][label]);
        measureUnits[label] = units[label];
      }
    });
    //console.log(measureUnits);
    //Populate data
    fetched.map((item) => {
      const formattedDate = new Intl.DateTimeFormat("it", options).format(
        moment.utc(item.timestamp).local()
      );
      dbLabels.map((label) => {
        if (item[label]) {
          const measure = new Array(formattedDate, item[label]);

          if (!chartDataset[label]) {
            //console.log(measure);
            chartDataset[label] = new Array(measure);
            //console.log(chartDataset[label]);
          } else {
            chartDataset[label].push(measure);
          }
        }
      });
    });
    //console.log(chartDataset)
    isLoading = false;
    // fetch(urlBase+"?idtag="+form.device+"&fromDate="+form.fromDate+"&toDate="+form.toDate)
    //   .then((res) => {
    //     if (!res.ok) {
    //       throw new Error("API does not respond - " + res.statusText);
    //     } else {
    //       console.log(res);
    //       return res.json();
    //     }
    //   })
    //   .then((data) => {
    //     console.log(data);

    //     let fetched = data.measurements.reverse();
    //     const options = {
    //       year: "numeric",
    //       month: "numeric",
    //       day: "numeric",
    //       hour: "numeric",
    //       minute: "numeric",
    //       second: "numeric",
    //     };
    //     //Populate measure unit
    //     // measurementLabels.map((label) => {
    //     //   if (fetched[0][label]) {
    //     //     //console.log(fetched[0][label]);
    //     //     measureUnits[label] = fetched[0][label].unit;
    //     //   }
    //     // });
    //     //console.log(measureUnits);
    //     //Populate data
    //     // fetched.map((item) => {
    //     //   const formattedDate = new Intl.DateTimeFormat("it", options).format(
    //     //     moment.utc(item.timestamp).local()
    //     //   );
    //     //   measurementLabels.map((label) => {
    //     //     if (item[label]) {
    //     //       const measure = new Array(formattedDate, item[label].value);

    //     //       if (!chartDataset[label]) {
    //     //         //console.log(measure);
    //     //         chartDataset[label] = new Array(measure);
    //     //         //console.log(chartDataset[label]);
    //     //       } else {
    //     //         chartDataset[label].push(measure);
    //     //       }
    //     //     }
    //     //   });
    //     // });
    //     //console.log(chartDataset)
    //     isLoading = false;
    //   })
    //   .catch((err) => {
    //     errorMessage = err;
    //     console.log(errorMessage);
    //     isLoading = false;
    //   });
  };

  const prepareLabels = (labels, intl) => {
    const options = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    return labels.map((label) =>
      new Intl.DateTimeFormat(intl, options).format(moment.utc(label).local())
    );
  };

  const submitForm = async () => {
    await fetchHistoryData();
  };

  onMount(() => {
    let dateNow = new Date();
    let datePast = new Date(new Date().setMonth(new Date().getMonth() - 1));
    //console.log(dateNow);
    //console.log(datePast);
    form.toDate = prepareDate(dateNow);
    form.fromDate = prepareDate(datePast);
  });
</script>

<Row class="mt-1">
  <Col>
    <Card>
      <CardHeader>
        <CardTitle>{$_("dataHistory")}</CardTitle>
        <CardSubtitle>{$_("searchtoplot")}</CardSubtitle>
      </CardHeader>
      <CardBody>
        <CentralineHistoryForm
          bind:form
          name="history"
          onSubmit={submitForm}
          bind:submitting={isLoading}
        />
      </CardBody>
    </Card>
  </Col>
</Row>
<Row>
  <Col>
    <Card>
      <CardBody class="text-center">
        {#if isLoading}
          <Spinner size="lg" />
        {:else if !isLoading && errorMessage}
          <Alert color={"danger"}>{errorMessage}</Alert>
        {:else if !isLoading && chartDataset}
          {#each measurementLabels as label, index}
            {#if chartDataset[label]}
              <div id={"chart-container" + "-" + index}>
                <SvelteFC
                  id={"chart-" + index}
                  chart={"chart-" + label}
                  {...getChartConfig(chartDataset[label], label, index)}
                />
              </div>
            {/if}
          {/each}
        {:else}
          <h4>{$_("emptyChartSpace")}</h4>
        {/if}
      </CardBody>
    </Card>
  </Col>
</Row>

<style>
  .chartcard {
    margin: auto;
  }
</style>
